module.exports = __webpack_public_path__ + "static/media/draugiem.c2a8dc74.svg";